import { connect } from 'react-redux'
import CollectionButtonView from 'components/ConversationHeader/Buttons/CollectionButton'
import { selectWidgetById } from 'ducks/widgets/selectors/widgets'
import { selectRoomById } from 'ducks/chat/selectors/rooms'
import { getRawId } from 'util/globalId'

const select = (state, props) => {
  const { collectionColor, channelId } =
    selectRoomById(state, props.conversationId) || {}
  const { name } = selectWidgetById(state, getRawId(channelId)) || {}

  return {
    color: collectionColor,
    name,
  }
}

export default connect(select)(CollectionButtonView)
